import React from 'react';
import PropTypes from 'prop-types';
import {FullscreenModal} from '@learningblocks/storybook-components/lib/FullscreenModal';
import {Content} from './Content';
import {Player} from './Player';
import {PowerSupplyContext} from '..';

import './style.scss';

export function ModalWindow(props) {
  const {running} = React.useContext(PowerSupplyContext);
  return (
    <FullscreenModal
      className='ps_modal'
      isOpen={props.modalOpen}
      close={props.toggleModal}
      size={'sim'}
      closeButton={true}
      notebookExpanded={props.notebookExpanded}
      lang={props.lang}
      >
      {!running && (
        <Content
          interactionProps={props.interactionProps}
          alert={props.alert}
          togglePower={props.togglePower}
          settingsData={props.settingsData}
          setTimer={props.setTimer}
          setVoltage={props.setVoltage}
          setCurrent={props.setCurrent}
          cablesData={props.cablesData}
          onClickStart={props.onClickStart}
          onClickStop={props.onClickStop}
          pluggedIn={props.pluggedIn}
        />
      )}
      <div className='timer_player'>
        <Player player={props.player} />
      </div>
    </FullscreenModal>
  );
}

ModalWindow.propTypes = {
  /**
   * specifies if modal window is open
   */
  modalOpen: PropTypes.bool,
  /**
   * callback function to trigger modal window open and close
   */
  toggleModal: PropTypes.func,

  ...Content.propTypes,
  /**
   * contains player component to play animation on start
   */
  player: PropTypes.element,
};
ModalWindow.defaulProps = {
  running: false,
};
